export namespace LPMobileStates {
    export function lpMobileStatesFactory() {
        const lpMobile = {
            params: {
                propertyInfo: {
                    propertyType: '',
                    bedrooms: '',
                    bedroomsPlus: '',
                    washrooms: '',
                    garages: '',
                    picture: '',
                },
                clientInfo: {
                    name: '',
                    phoneSuffix: '+1',
                    phone: '',
                    salutations: '',
                    email: '',
                },
                comparitives: [],
                subjectSearchText: '',
                stats: [],
                googleFomattedLocation: null,
            },
        };
        return lpMobile;
    }

    export function mutations() {
        return {
            lpMobileSetPropertyInfo(state: any, v: any) {
                state.lpMobile.params.propertyInfo = v;
            },
            lpMobileSetClientInfo(state: any, v: any) {
                state.lpMobile.params.clientInfo = v;
            },
            lpMobileSetComparitives(state: any, v: any) {
                state.lpMobile.params.comparitives = v;
            },
            lpMobileSetSubjectSearchText(state: any, v: any) {
                state.lpMobile.params.subjectSearchText = v;
            },
            lpMobileSetGoogleFomattedLocation(state: any, v: any) {
                state.lpMobile.params.googleFomattedLocation = v;
            },
            lpMobileSetStats(state: any, v: any) {
                state.lpMobile.params.stats = v;
            }
        };
    }
}
